import * as React from 'react';

const YesIcon: React.FC<React.SVGProps<SVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M11.8928 4.71973C12.1856 4.4269 12.6605 4.42704 12.9534 4.71973C13.2463 5.01262 13.2463 5.48738 12.9534 5.78027L6.87134 11.8623C6.57844 12.1552 6.10368 12.1552 5.81079 11.8623L3.04614 9.09766C2.7534 8.80476 2.75331 8.32995 3.04614 8.03711C3.339 7.7444 3.81383 7.74441 4.10669 8.03711L6.34106 10.2715L11.8928 4.71973Z"
      fill="#745CFF"
    />
  </svg>
);

export default YesIcon;
